module.exports = __webpack_public_path__ + "img/photodefaultportrait.d9ce7723.png";